import styled, { css, keyframes } from 'styled-components'
import { MostUsageCVWrapper } from '../../Dashboard/MostUsageCV/MostUsageCV.css'
import { Col, Popup, Row, SingleRadio, Skeleton, colors } from '@microfrontends/react-components'

export const AttachedCVWrapper = styled.div`
    margin: 0 0 16px 0;
`

export const CVSection = styled.div<{ isFirst?: boolean }>`
    display: flex;
    flex-direction: column;
    padding: 24px;
    border-radius: 12px;
    background: #FFF;
    align-items: flex-start;
    margin-top: ${({ isFirst }) => isFirst ? '0' : '16px'};
    margin-bottom: 12px;
    ${MostUsageCVWrapper} {
        background: #EFF5FF;
        padding: 16px;
        border-radius: 12px;
        width: 100%;
    }
    &:last-child {
        margin-bottom: 0;
    }
    @media screen and (max-width: 768px) {
        background-color: ${colors.neutral[95]};
        padding: 12px;
    }
    > label {
        > div {
            flex-direction: column;
        }
    }
`
export const UploadFileInput = styled.input`
    opacity: 0;
    position: absolute;
    pointer-events: none;
`

export const CVSectionTitle = styled.h2`
    color: ${colors.neutral[50]};
    font-size: 16px;
    font-weight: 600;
    line-height: 40px;
    margin-bottom: 16px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    > button {
        color: ${colors.primary[40]};
        > svg {
            margin-right: 6px;
        }
    }
`

export const NoAttachmentResult = styled.div`
    padding: 32px;
    background: #F9F9F9;
    display: flex;
    border-radius: 6px;
    flex-direction: column;
    align-items: center;
    width: 100%;
`

export const NoAttachmentTitle = styled.p`
    color: #333;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    text-align: center;
    margin-top: 16px;
`

export const NoAttachmentDescription = styled.p`
    color: #939393;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: center;
`

export const NoAttachmentAction = styled.div``

export const CVTemplateList = styled.div`
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    a {
        display: inline-flex;
    }
`

export const UploadFileItem = styled.div<{ isMobile?: boolean }>`
    position: relative;
    width: 100%;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    border-radius: 12px;
    margin-bottom: 8px;
    border: 1px solid #fff;
    &:last-child {
        margin-bottom: 0;
    }
    &:hover {
        background-color: ${colors.primary[99]};
        border: 1px solid ${colors.primary[90]};
    }
    ${({ isMobile }) => {
        if (!isMobile) {
            return ''
        }
        return css`
            padding-top: 4px;
            flex-direction: column;
        `
    }}
`

export const LeftSideContent = styled.div`
    width: calc(100% - 40px);
    display: flex;
`

export const CVTitle = styled.a`
    line-height: 20px;
    font-weight: 500;
    color: #333;
    font-size: 16px;
    font-size: 16px;
    display: flex;
    justify-content: flex-start;
    @media screen and (max-width: 768px) {
        flex-direction: column;
    }
`

export const ActionItem = styled.a`
    line-height: 20px;
    font-weight: 400;
    color: ${colors.primary[40]};
    font-size: 14px;
    margin-top: 8px;
    display: flex;
    justify-content: flex-start;
    @media screen and (max-width: 768px) {
        flex-direction: column;
    }
`

export const SpanTitle = styled.span<{ isMobile: boolean; minWidth: number }>`
    ${({ isMobile }) => {
        if (!isMobile) {
            return ''
        }
        return css`
            width: 100%;
        `
    }}
    ::before {
        content: attr(data-filename);
        text-overflow: ellipsis;
        display: inline-block;
        max-width: ${({ minWidth }) => `calc(100% - ${minWidth}px)`};
        overflow: hidden;
        white-space: pre;
    }
    ::after {
        content: attr(data-extension);
        text-overflow: clip;
        display: inline-block;
        max-width: ${({ minWidth }) => minWidth}px;
        min-width: ${({ minWidth }) => minWidth}px;
        overflow: hidden;
        white-space: pre;
    }
`

export const TitleH3 = styled.h3<{ isHaveSearchable: boolean; isMobile: boolean; minWidth: number; isLangVN: boolean }>`
    font-size: 16px;
    margin-right: 6px;
    ${({ isMobile, isHaveSearchable }) => {

        if (isMobile) {
            return css`
                width: 100%;
            `
        }
        return isHaveSearchable ? css<{ isLangVN: boolean }>`
            width: fit-content;
            max-width: calc(100% - ${({ isLangVN }) => isLangVN ? 140 : 100}px);
        ` : css`
            width: 100%;
        `
    }};
    ::before {
        content: attr(data-filename);
        text-overflow: ellipsis;
        display: inline-block;
        max-width: ${({ minWidth }) => `calc(100% - ${minWidth}px)`} !important;
        overflow: hidden;
        white-space: pre;
    }
    ::after {
        content: attr(data-extension);
        text-overflow: clip;
        display: inline-block;
        max-width: 10%;
        min-width: ${({ minWidth}) => minWidth}px;
        width: 26px;
        overflow: hidden;
        white-space: pre;
    }
    @media screen and (min-width: 768px) and (max-width: 825px) {
        ::before {
            max-width: 80%;
        }
        ::after {
            max-width: 20%;
        }
    }
    @media screen and (min-width: 825px) and (max-width: 846px) {
        ::before {
            max-width: 86%;
        }
        ::after {
            max-width: 14%;
        }
    }
    @media screen and (min-width: 847px) and (max-width: 922px) {
        ::before {
            max-width: 88%;
        }
        ::after {
            max-width: 12%;
        }
    }
`

export const CVText = styled.span`
    color: #333;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    margin-bottom: 4px;
    &:last-child {
        margin-bottom: 0;
    }
`

export const PdfPreview = styled.iframe`
    width: 88px;
    height: 124px;
    margin-right: 16px;
    border: none;
    pointer-events: none;
    overflow: hidden !important;
`

export const FileInfo = styled.div`
    width: calc(100% - 52px);
    max-width: calc(100% - 52px);
    @media screen and (max-width: 768px) {
        width: 100%;
        max-width: 100%;
    }
`

export const TagSearchable = styled.span<{ isMobile?: boolean }>`
    min-width: 100px;
    background-color: ${colors.green[90]};
    color: ${colors.green[50]};
    border-radius: 14px;
    display: flex !important;
    height: 24px;
    padding: 2px 8px;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    justify-content: center;
    ${({ isMobile }) => {
        if (!isMobile) {
            return ''
        }
        return css`
            position: absolute;
            right: -1px;
            bottom: -1px;
            border-radius: 12px 0 12px 0;
        `
    }}
`

export const AttachedCVButtonWrapper = styled.div`
    width: 100%;
    margin-top: 16px;
    > button {
        width: 100%;
    }
`

const progressBarStripes = keyframes`
    0% {
        background-position-x: 32px;
    }
`

export const ProgressBarItem = styled.div`
    border-radius: 5px;
    background-color: #d9e6ff;
    width: 100%;
    width: 386px;
    height: 10px;
    position: relative;
    overflow: hidden;
`

export const Progress = styled.span<{ color?: string; isUploading?: boolean }>`
    background-color: ${({ color }) => color ?? colors.primary[40]};
    border-radius: 5px;
    height: 10px;
    display: flex;
    ${({ isUploading }) => {
        if (!isUploading) {
            return ''
        }
        return css`
            animation: 1s linear infinite ${progressBarStripes};
            background-image: linear-gradient(
                45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent
            );
            background-size: 32px 32px;
        `
    }}
`

export const UploadRowTitle = styled(Row)`
    border-bottom: 1px solid ${colors.neutral[95]};
`

export const UploadColFilename = styled(Col)`
    line-height: 40px;
    /* width: fit-content;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    word-break: break-word; */
    color: #333;
    font-size: 16px;
    font-weight: 500;

    display: inline-block;
    overflow: hidden;
    white-space: pre;

`

export const UploadColViewMore = styled(Col)`
    display: flex;
    justify-content: flex-end;
`

export const UploadRowContent = styled(Row)`
    padding-top: 8px;
`

export const ColPdfView = styled(Col)`
    width: 64px;
    /* height: 80px; */
    min-height: 46px;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #fff;
    ${PdfPreview} {
        width: 64px;
        overflow: hidden;
    }
`

export const UploadRowBottomTag = styled(Row)`
    height: 14px;
`

export const DeleteContent = styled.div`
    padding: 8px;
    text-align: center;
    p {
        margin-bottom: 16px;
        word-break: break-word;
        &:last-child {
            margin: 0;
        }
    }
`

export const CVReplaceContent = styled.div`
    text-align: center;
    padding: 8px 8px 0 8px;
    > p {
        margin: 0 0 16px 0;
    }
    > b {
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
    }
    [name="replace-attached-cv"] {
        p {
            text-align: left;
        }
    }
    ul {
        margin-top: 8px;
        margin-bottom: 0;
        padding-left: 0;
    }
    @media screen and (max-width: 768px) {
        ul {
            padding: 0;
        }
    }
`

export const CustomPopup = styled(Popup)`
    @media screen and (min-width: 769px) {
        .vnw-popup-content {
            width: 520px !important;
        }
    }
`

export const CustomSingleRadio = styled(SingleRadio)<{ isActive?: boolean }>`
    border-radius: 8px;
    ${({ isActive }) => {
        if (!isActive) {
            return ''
        }
        return css`
            background-color: ${colors.primary[95]};
        `
    }}
    p {
        text-align: left;
    }
`

export const CustomLabelSingleRadio = styled.span`
    text-align: left;
    display: flex;
    align-items: center;
`
export const FileLabel = styled.span<{ isSearchable: boolean; minWidth: number }>`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    ::before {
        content: attr(data-filename);
        text-overflow: ellipsis;
        display: inline-block;
        max-width: ${({ minWidth }) => `calc(100% - ${minWidth}px)`} !important;
        overflow: hidden;
        white-space: pre;
    }
    ::after {
        content: attr(data-extension);
        text-overflow: clip;
        display: inline-block;
        max-width: ${({ minWidth }) => minWidth}px;
        min-width: ${({ minWidth }) => minWidth}px;
        overflow: hidden;
        white-space: pre;
    }
    ${({ isSearchable }) => {
        if (isSearchable) {
            return css`
                width: calc(100% - 120px);
            `
        }
        return css`
            width: 100%;
        `
    }}
`

export const SearchableTag = styled.span`
    border-radius: 14px;
    margin-left: 8px;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    padding: 2px 6px;
    background-color: ${colors.green[90]};
    color: ${colors.green[50]};
    flex-shrink: 0;
`

export const WarningAlert = styled.div`
    background-color: ${colors.yellow[95]};
    border-radius: 8px;
    padding: 8px;
    display: flex;
    > div {
        margin-left: 8px;
        text-align: left;
    }
`

export const CustomSkeleton = styled(Skeleton)`
    margin-bottom: 8px;
    border-radius: 12px;
    &:first-child {
        margin-top: 8px;
    }
    &:last-child {
        margin-bottom: 0;
    }
`

export const AttachIcon = styled.a`
    width: 40px;
    min-height: 46px;
    display: flex;
    align-items: center;
    padding-right: 16px;
    @media screen and (max-width: 768px) {
        width: 100%;
        height: 100%;
        justify-content: center;
    }
`

export const RenameContent = styled.div`

`

export const ErrorLabel = styled.p`
    display: inline-block;
    margin-bottom: 0;
    font-size: 12px;
    color: #FF4A53;
    margin-top: 4px;
`
